// Copyright ©️ 2026 eVolve MEP, LLC

import { BasePageHeader } from 'components/Mantine/BasePageHeader';

export const ContentRequestPage = () => (
  <>
    <BasePageHeader title="EVOLVE Content" hideGlobalFilters />
    <iframe
      src="https://js.hsforms.net/ui-forms-embed-components-app/frame.html?_hsPortalId=21510560&_hsFormId=bf9614e6-a8d3-43c1-96a2-0982d7ddb21b&_hsIsQa=false&_hsHublet=na1&_hsDisableScriptloader=true&_hsDisableRedirect=true&_hsInstanceId=393ce5f1-c019-4cc0-87b9-bcb467a90f1a"
      height={1200}
      width="100%"
      style={{ maxWidth: '1200px' }}
      title="Content Request Form"
    />
  </>
);
